import {Injectable} from '@angular/core';
import {DcpOrder} from '@app/model/order/dcp-order.model';
import {EntryGroupService} from '@app/product/services/entry-group.service';
import {DcpEntryGroup} from '@dcp/configurator';
import {OrderEntry} from '@spartacus/cart/base/root/models/cart.model';
import {CxEvent} from '@spartacus/core';
import {OrderPlacedEvent} from '@spartacus/order/root';
import {Observable} from 'rxjs';
import {DcpDataService} from './dcp-data.service';
import {AdobeTrackingData, AdobeTrackingProductData} from './models/adobe-tracking-data';

@Injectable({
  providedIn: 'root'
})
export class DcpOrderPlacedEventDataService extends DcpDataService<AdobeTrackingData> {

  constructor(
    private entryGroupService: EntryGroupService,
  ) {
    super();
  }

  fillData(event: OrderPlacedEvent, data?: AdobeTrackingData): AdobeTrackingData {
    if (!data) {
      data = {
        events: {},
      };
    }
    const order = event.order as unknown as DcpOrder;
    data.events.purchase = true;
    if (!data.ecommerce) {
      data.ecommerce = {};
    }
    data.ecommerce.currency = order.totalPrice?.currencyIso;
    data.ecommerce.purchaseID = order.code;
    const rootGroups = this.entryGroupService.collectEntryGroups(this.entryGroupService.isRoot, order.entryGroups);
    data.ecommerce.products = [];
    rootGroups.forEach((rootGroup) => {
      let relevantEntryGroups: DcpEntryGroup[];
      if (this.entryGroupService.collectEntryGroups(this.entryGroupService.isEdition, rootGroup.entryGroups).length) {
        relevantEntryGroups = this.entryGroupService.collectEntryGroups(
          (entryGroup) => !this.entryGroupService.isProduct(entryGroup),
          rootGroup.entryGroups
        );
      } else {
        relevantEntryGroups = rootGroup.entryGroups;
      }
      data.ecommerce.products = data.ecommerce.products.concat(
        relevantEntryGroups
          .reduce((acc, entryGroup) => acc.concat(entryGroup.entries), [])
          .map(this.convertEntryToTrackingProduct)
      );
    });
    return data;
  }

  getData(event: CxEvent): AdobeTrackingData | Observable<AdobeTrackingData> {
    if (!(event instanceof OrderPlacedEvent)) {
      return undefined;
    }
    return this.fillData(event);
  }

  protected convertEntryToTrackingProduct(orderEntry: OrderEntry): AdobeTrackingProductData {
    return {
      ID: orderEntry.product.supplierAlternativeAID,
      quantity: orderEntry.quantity,
      price: orderEntry.totalPrice.formattedValue,
      name: orderEntry.product.name,
      partnerName: orderEntry.product.vendor.name,
    };
  }
}
